import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import Splide from '@splidejs/splide';
export var featuredTabbedContent = function featuredTabbedContent() {
  Alpine.data('featuredTabbedContent', function () {
    return {
      activeTabRef: '',
      activeTabIndex: 0,
      carousel: undefined,
      init: function init() {
        this.tabButtons = this.$el.querySelectorAll('[x-bind="bindTabButton"]');
        this.tabButtonsCount = this.tabButtons.length - 1;
        this.activeTabIndex = 0;
        this.activeTabRef = this.tabButtons[0].getAttribute('data-tab-ref');
        this.setActiveTab();
        this.setActiveTabFromUrl();
        this.initSlider();
      },
      setActiveTabFromUrl: function setActiveTabFromUrl() {
        var _this = this;
        var activeTabHash = window.location.hash.substring(1);
        if (activeTabHash) {
          this.tabButtons.forEach(function (button) {
            if (button.getAttribute('data-tab-ref') === activeTabHash) {
              _this.activeTabIndex = button.getAttribute('data-tab-index');
              _this.setActiveTab(true); // Explicitly update if hash exists
            }
          });
        }
      },
      updateHistory: function updateHistory() {
        window.history.replaceState({}, document.title, "#".concat(this.activeTabRef));
        window.dispatchEvent(new Event('hashchange'));
      },
      setActiveTab: function setActiveTab() {
        var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (this.activeTabIndex < 0) {
          this.activeTabIndex = this.tabButtonsCount;
        }
        if (this.activeTabIndex > this.tabButtonsCount) {
          this.activeTabIndex = 0;
        }
        this.activeTabRef = this.tabButtons[this.activeTabIndex].getAttribute('data-tab-ref');
        if (focus) {
          this.tabButtons[this.activeTabIndex].focus();
          this.updateHistory();
        }
      },
      bindTabButton: {
        // eslint-disable-next-line func-names
        '@click.prevent': function clickPrevent() {
          this.activeTabIndex = this.$el.getAttribute('data-tab-index');
          this.setActiveTab(true);
        },
        // eslint-disable-next-line func-names
        '@keydown': function keydown(e) {
          // Active last tab on `End` keydown.
          if (e.keyCode === 35) {
            this.activeTabIndex = this.tabButtonsCount;
          }

          // Active first tab on `Home` keydown.
          if (e.keyCode === 36) {
            this.activeTabIndex = 0;
          }
        },
        // eslint-disable-next-line func-names
        '@keydown.right': function keydownRight() {
          this.activeTabIndex += 1;
          this.setActiveTab(true);
        },
        // eslint-disable-next-line func-names
        '@keydown.left': function keydownLeft() {
          this.activeTabIndex -= 1;
          this.setActiveTab(true);
        },
        // eslint-disable-next-line func-names
        ':aria-selected': function ariaSelected() {
          var tabId = this.$el.getAttribute('data-tab-ref');
          return this.activeTabRef === tabId;
        },
        // eslint-disable-next-line func-names
        ':tabindex': function tabindex() {
          var tabId = this.$el.getAttribute('data-tab-ref');
          return this.activeTabRef === tabId ? false : -1;
        }
      },
      bindTab: {
        // eslint-disable-next-line func-names
        'x-show': function xShow() {
          var tabId = this.$el.getAttribute('data-tab-ref');
          return tabId === this.activeTabRef;
        }
      },
      initSlider: function initSlider() {
        if (this.carousel === undefined) {
          this.carousel = new Splide('.featured-tabbed-content-carousel', {
            type: 'loop',
            perPage: 1
          }).mount();
        }
      }
    };
  });
};